import { TypeRampValues } from '@genesislcap/foundation-utils';
import { parseColorHexRGB } from '@microsoft/fast-colors';
import { PaletteRGB, SwatchRGB, accentPalette, controlCornerRadius, designUnit, neutralPalette, baseLayerLuminance, density, strokeWidth, bodyFont, typeRampBaseFontSize, typeRampBaseLineHeight, typeRampMinus1FontSize, typeRampMinus1LineHeight, typeRampMinus2FontSize, typeRampMinus2LineHeight, typeRampPlus1FontSize, typeRampPlus1LineHeight, typeRampPlus2FontSize, typeRampPlus2LineHeight, typeRampPlus3FontSize, typeRampPlus3LineHeight, typeRampPlus4FontSize, typeRampPlus4LineHeight, typeRampPlus5FontSize, typeRampPlus5LineHeight, typeRampPlus6FontSize, typeRampPlus6LineHeight, } from '@microsoft/fast-components';
export const provideTokens = (tokens, values, element) => {
    const setToken = element
        ? (token, value) => token.setValueFor(element, value)
        : (token, value) => token.withDefault(value);
    Object.keys(tokens).forEach((token) => {
        const valueKey = `${token}Value`;
        if (values[valueKey]) {
            setToken(tokens[token], values[valueKey]);
        }
    });
};
export function designToken(token) {
    return (source, key) => {
        source[key + 'Changed'] = function (prev, next) {
            if (next !== undefined && next !== null) {
                token.setValueFor(this, next);
            }
            else {
                token.deleteValueFor(this);
            }
        };
    };
}
export const swatchConverter = {
    toView(value) {
        if (value === null || value === undefined) {
            return null;
        }
        return value === null || value === void 0 ? void 0 : value.toColorString();
    },
    fromView(value) {
        if (value === null || value === undefined) {
            return null;
        }
        const color = parseColorHexRGB(value);
        return color ? SwatchRGB.create(color.r, color.g, color.b) : null;
    },
};
export const paletteFromHex = (hexColor) => PaletteRGB.from(SwatchRGB.from(parseColorHexRGB(hexColor)));
const defaultExclusions = ['baseClass', 'baseName', 'shadowOptions', 'styles', 'template'];
export const getDefaultConfig = (definition, exclusions = defaultExclusions) => {
    const keys = Object.keys(definition).filter((k) => !exclusions.includes(k));
    return keys.reduce((accumulator, key) => {
        accumulator[key] = definition[key];
        return accumulator;
    }, {});
};
export const getExports = (registrationFunction) => {
    const { definition } = registrationFunction();
    const { shadowOptions, styles, template } = definition;
    const defaultConfig = getDefaultConfig(definition);
    return { shadowOptions, styles, template, defaultConfig };
};
export const getTypeRampValue = (baseTypeRamp, value) => {
    const regex = /^(\d+)([a-z]+)/i;
    const matches = baseTypeRamp.match(regex);
    const baseFontValue = matches[1];
    const baseUnit = matches[2];
    const typeRampSize = Number(baseFontValue) + value;
    return typeRampSize + baseUnit;
};
export const configureDesignSystem = (provider, config) => {
    const designTokens = config.design_tokens;
    accentPalette.setValueFor(provider, paletteFromHex(designTokens.color.accent.$value));
    neutralPalette.setValueFor(provider, paletteFromHex(designTokens.color.neutral.$value));
    bodyFont.setValueFor(provider, designTokens.fontFamily.bodyFont.$value);
    baseLayerLuminance.setValueFor(provider, designTokens.mode.luminance.$value);
    density.setValueFor(provider, designTokens.style.density.$value);
    controlCornerRadius.setValueFor(provider, designTokens.style.borderRadius.$value);
    strokeWidth.setValueFor(provider, designTokens.style.strokeWidth.$value);
    designUnit.setValueFor(provider, designTokens.space.designUnit.$value);
    typeRampBaseFontSize.setValueFor(provider, designTokens.typography.baseFontSize.$value);
    typeRampBaseLineHeight.setValueFor(provider, designTokens.typography.baseLineHeight.$value);
    const baseFontSize = typeRampBaseFontSize.getValueFor(provider);
    const baseLineHeight = typeRampBaseLineHeight.getValueFor(provider);
    typeRampMinus1FontSize.setValueFor(provider, getTypeRampValue(baseFontSize, TypeRampValues.minusOne));
    typeRampMinus1LineHeight.setValueFor(provider, getTypeRampValue(baseLineHeight, TypeRampValues.minusOne));
    typeRampMinus2FontSize.setValueFor(provider, getTypeRampValue(baseFontSize, TypeRampValues.minusTwo));
    typeRampMinus2LineHeight.setValueFor(provider, getTypeRampValue(baseLineHeight, TypeRampValues.minusTwo));
    typeRampPlus1FontSize.setValueFor(provider, getTypeRampValue(baseFontSize, TypeRampValues.plusOne));
    typeRampPlus1LineHeight.setValueFor(provider, getTypeRampValue(baseLineHeight, TypeRampValues.plusOne));
    typeRampPlus2FontSize.setValueFor(provider, getTypeRampValue(baseFontSize, TypeRampValues.plusTwo));
    typeRampPlus2LineHeight.setValueFor(provider, getTypeRampValue(baseLineHeight, TypeRampValues.plusTwo));
    typeRampPlus3FontSize.setValueFor(provider, getTypeRampValue(baseFontSize, TypeRampValues.plusThree));
    typeRampPlus3LineHeight.setValueFor(provider, getTypeRampValue(baseLineHeight, TypeRampValues.plusThree));
    typeRampPlus4FontSize.setValueFor(provider, getTypeRampValue(baseFontSize, TypeRampValues.plusFour));
    typeRampPlus4LineHeight.setValueFor(provider, getTypeRampValue(baseLineHeight, TypeRampValues.plusFour));
    typeRampPlus5FontSize.setValueFor(provider, getTypeRampValue(baseFontSize, TypeRampValues.plusFive));
    typeRampPlus5LineHeight.setValueFor(provider, getTypeRampValue(baseLineHeight, TypeRampValues.plusFive));
    typeRampPlus6FontSize.setValueFor(provider, getTypeRampValue(baseFontSize, TypeRampValues.plusSix));
    typeRampPlus6LineHeight.setValueFor(provider, getTypeRampValue(baseLineHeight, TypeRampValues.plusSix));
};
